// This file is automatically generated. Do not edit it directly.
// NOTE: the Database types are intentionally imported from @/types/database.types
// (a protected file) instead of ./types, which gets reset to an empty template.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://lppaahrhcigdrhvkwwqz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxwcGFhaHJoY2lnZHJodmt3d3F6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MTMxODcsImV4cCI6MjA3MzE4OTE4N30.nFORcqiy9FawRoO15tkzFmrU6r2qaL098bfSsZnQVg4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});